import { Trans } from '@lingui/macro'
import Title from 'Root/App/Title'
import Image from 'next/image'

const CreatorInviteInfo = ({
  creatorName,
  creatorPicture,
}: {
  creatorName: string
  creatorPicture: string
}) => (
  <span id="creator-avatar" className="flex flex-col gap-6 items-center">
    <div className="relative w-12 h-12">
      <Image
        src={creatorPicture}
        alt="creator-avatar"
        fill
        className="object-cover rounded-full"
      />
    </div>

    <Title size="M" className="text-center">
      {creatorName}
    </Title>

    <Title size="XS" className="text-gray-400 text-center">
      <Trans>
        Continua per accedere al Learning Workspace di {creatorName}
      </Trans>
      .
    </Title>
  </span>
)

export default CreatorInviteInfo
